module.exports = __webpack_public_path__ + "static/media/amp-guitar.01f61483.svg";